import styled from 'styled-components';
import { rgba } from 'polished';

export default styled.p`
	color: ${(props) => props.theme.colors.green};
	background: ${(props) => rgba(props.theme.colors.green, 0.25)};
	padding: 8px;
	border-radius: 2px;
	margin: 10px 0px;
`;
